export default function MutedVideo({ video, className = "", testId }) {
    return (
        <video
            src={video.src}
            poster={video.poster}
            aria-label={video.alt}
            data-testid={testId}
            muted
            autoPlay
            loop
            playsInline
            preload="metadata"
            className={className}
        />
    );
}
